import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SelectivePreloadingStrategy, AuthGuard } from 'app/resources/services/index';
import { LoginComponent } from 'app/public/login/login.component';
import { MakepwdComponent } from 'app/public/makepwd/makepwd.component';
import { CadastroUsuarioComponent } from 'app/cadastro-usuario/cadastro-usuario.component';
import { ChaveDeAcessoComponent } from './public/chave-de-acesso/chave-de-acesso.component';
import { InstitucionalComponent } from './public/institucional/institucional.component';

const routes: Routes = [
  {
    path: '',
    component: InstitucionalComponent
  }, {
    path: 'login',
    component: LoginComponent
  }, {
    path: 'home',
    loadChildren: './body/body.module#BodyModule',
  }, {
    path: 'makepwd',
    component: MakepwdComponent
  }, {
    path: 'novo-usuario',
    component: CadastroUsuarioComponent
  }
  // , {
  //   path: 'recuperar-chave-de-acesso',
  //   component: ChaveDeAcessoComponent
  // }
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes,
    { preloadingStrategy: SelectivePreloadingStrategy, useHash: true },
  )],
  exports: [RouterModule],
  providers: [SelectivePreloadingStrategy]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts